import React from 'react';
import FinsightChart from '@/creditflowresearch/ui/common/components/FinsightChart';
import headerConfig from './headerConfig';
import emptyChartSettings from './emptyChartSettings';
import { useBondsChartsContext } from '@/creditflowresearch/application/Bonds/charts/BondsChartsContext';

const Charts = () => {
  const { dealer, sector } = useBondsChartsContext();
  const { actions: dealerActions, ...dealerData } = dealer;
  const { actions: sectorActions, ...sectorData } = sector;

  const dealerHeaderConfig = headerConfig(dealer);
  const sectorHeaderConfig = headerConfig(sector);

  const mapCharts = [
    { key: 'dealerChart', dataTest: 'dealerChart', headerConfig: dealerHeaderConfig, ...dealerData },
    { key: 'sectorChart', dataTest: 'sectorChart', headerConfig: sectorHeaderConfig, ...sectorData },
  ];

  return mapCharts.map(({ key, ...chart }) => {
    return <FinsightChart key={ key } { ...chart } emptyChartSettings={ emptyChartSettings } />;
  });
};

export default Charts;
